// 英文
import srLocale from 'element-ui/lib/locale/lang/sr'


const sr = {
  // ============= 登录 start ============
 "验证码": "Verifikacioni kod",
"登录": "Prijavljivanje",
"请输入验证码": "Molimo unesite verifikacioni kod",
"验证码不正确!": "Netačan verifikacioni kod!",
"请输入账号": "Molimo unesite svoj nalog",
"请输入密码": "Molimo unesite svoju lozinku",
"访问地址有误，请在shop后台核实": "Adresa pristupa nije ispravna, molimo proverite u pozadini prodavnice",
  // ============= 登录 end ============

  // ============= Layout start ============
 "全屏模式": "Režim prikaza na celom ekranu",
"首页": "Početna stranica",
"此操作将退出登录, 是否继续?": "Ova operacija će se odjaviti, da li želite da nastavite?",
"已取消退出": "Odjavljivanje je otkazano",
"您有一个新订单": "Imate novu porudžbinu",
"无法获取当前门店信息，请重新登录": "Nemoguće je dobiti trenutne informacije o prodavnici, molimo ponovo se prijavite",
"收银台": "Blagajna",
"收银": "Blagajna",
"桌台": "Sto",
"订单": "Porudžbina",
  // ============= Layout end  ============

  // ============= 首页 start ============
  "查询会员": "Pretraga članova",
  "商品改价": "Promena cene",
  "商品删行": "Brisanje stavke",
  "整单取消": "Otkazivanje narudžbine",
  "取单": "Dohvatanje narudžbine",
  "挂单": "Zadrži narudžbinu",
  "折扣": "Popust",
  "抹零": "Zaokruži",
  "请输入内容": "Molimo unesite sadržaj",
  "收银员": "Blagajnik",
  "消费方式": "Način plaćanja",
  "店内就餐": "Jedenje u restoranu",
  "打包带走": "Poneti sa sobom",
  "商品名称": "Naziv proizvoda",
  "商品价格": "Cena proizvoda",
  "商品数量": "Količina proizvoda",
  "应收": "Ukupno za naplatu",
  "包装费": "Trošak pakovanja",
  "优惠": "Posebna ponuda",
  "数量": "Količina",
  "件": "Komad",
  "实收": "Primljeno",
  "收款": "Primi uplatu",
  "请选择商品": "Molimo odaberite proizvode",
  "确定要删除": "Da li ste sigurni da želite da obrišete",
  "提示": "Savet",
  "确定": "Potvrdi",
  "请先将购物车内的商品挂单或结账后再取单": "Molimo zadržite ili završite kupovinu u korpi pre nego što preuzmete narudžbinu",
  "确定要整单取消吗?": "Da li ste sigurni da želite da otkažete narudžbinu?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Molimo unesite broj telefona člana radi pretrage, zatim kliknite na potvrdi",
  "请输入会员手机号": "Molimo unesite broj telefona člana",
  "会员昵称": "Pseudonim člana",
  "余额总计": "Ukupno stanje",
  "退出": "Izlaz",
  "该用户不存在": "Ovaj korisnik ne postoji",
  "折扣抹零": "Popust/Zaokruživanje",
  "当前价格": "Trenutna cena",
  "改价": "Izmeni cenu",
  "实付价格": "Stvarna cena",
  "请输入实付价格": "Molimo unesite stvarnu cenu",
  "优惠折扣": "Stopa popusta",
  "请输入优惠折扣": "Molimo unesite stopu popusta",
  "抹分": "Zaokruži na najbližu desetinu",
  "抹角": "Zaokruži na najbliži dolar",
  "四舍五入到角": "Zaokruži na najbližu desetinu",
  "四舍五入到元": "Zaokruži na najbliži dolar",
  "确 定": "Potvrdi",
  "价格不能为空": "Cena ne sme biti prazna",
  "折扣不能为空": "Popust ne sme biti prazan",
  "修改价格": "Izmeni cenu",
  "本次售价": "Trenutna prodajna cena",
  "请输入本次售价": "Molimo unesite trenutnu prodajnu cenu",
  "清空": "Očisti",
  "确认": "Potvrdi",
  "商品详情": "Detalji proizvoda",
  "单位": "Jedinica",
  "规格": "Specifikacije",
  "加料": "Dodatni sastojci",
  "取消": "Otkaži",
  "现金收款": "Plaćanje gotovinom",
  "余额收款": "Plaćanje preko stanja",
  "其他方式": "Drugi načini",
  "应收金额": "Ukupan iznos za naplatu",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Kupci mogu platiti korišćenjem QR koda i drugih metoda u prodavnici. Nakon potvrde uspešne uplate, kliknite 'Potvrdi plaćanje' kako biste završili transakciju.",
  "微信支付": "WeChat Pay",
  "支付宝支付": "Alipay",
  "pos刷卡": "POS kartično plaćanje",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Unesite članski ID kako biste pronašli člana, zatim kliknite na potvrdi",
  "请输入会员ID": "Molimo unesite članski ID",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Prijavljeni članovi mogu samo da sakupljaju poene i nisu kvalifikovani za dodatne privilegije.",
  "取消收款": "Otkaži plaćanje",
  "订单总价": "Ukupna cena narudžbine",
  "挂单时间": "Vreme čekanja narudžbine",
  "删除": "Obriši",
  "多语言小票打印": "Štampanje računa na više jezika",
  "打印语言": "Jezik štampanja",
  "中文": "Chinese",
  "英语": "Engleski",
  "德语": "Nemački",
  "法语": "Francuski",
  "西班牙语": "Španski",
  "意大利语": "Italijanski",
  "克罗地亚": "Hrvatski",
  "斯洛文尼亚": "Slovenački",
  "匈牙利语": "Mađarski",
  "塞尔维亚语": "Cрпскијезик",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
 "未开台": "Nije otvoreno",
  "已开台": "Otvorena tabla",
  "就餐中": "Ručak",
  "刷新": "Osveži",
  "整单清空": "Obriši celu narudžbinu",
  "转台": "Promeniti sto",
  "打印预结单": "Štampaj preliminarni račun",
  "催菜": "Pohitaj sa naručivanjem",
  "人数": "Broj gostiju",
  "订单来源": "Izvor narudžbine",
  "请点击左侧桌号台": "Molimo kliknite na broj stola sa leve strane",
  "点选已开台桌台，可以在此查看点餐信息。": "Izaberite otvoren sto da biste videli detalje narudžbine ovde.",
  "服务费": "Troškovi usluge",
  "税费": "Porez",
  "协助点餐": "Pomoć pri naručivanju",
  "协助加餐": "Pomoć pri dodavanju stavki",
  "结账": "Plaćanje",
  "完成": "Završi",
  "价格": "Cena",
  "请选择": "Molimo izaberite",
  "已取消": "Otkazano",
  "确定要打印小票吗?": "Da li ste sigurni da želite da štampate račun?",
  "确定要关闭桌台并取消订单吗?": "Da li ste sigurni da želite da zatvorite sto i otkažete narudžbinu?",
  "请选择桌号": "Molimo izaberite broj stola",
  "就餐人数": "Broj osoba za ručak",
  "下单": "Naruči",
  "返回": "Nazad",
  "确定要商品删行吗?": "Da li ste sigurni da želite da obrišete red sa stavkama?",
  "请选择就餐人数": "Molimo izaberite broj osoba za ručak",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Vreme narudžbine",
  "起始时间": "Početno vreme",
  "店内订单": "Narudžbina u prodavnici",
  "自提订单": "Narudžbina za preuzimanje",
  "外卖订单": "Narudžbina za dostavu",
  "名称": "Ime",
  "支付时间": "Vreme plaćanja",
  "状态": "Stanje",
  "单价": "Jedinična cena",
  "金额": "Iznos",
  "税率": "Stopa poreza",
  "税费金额": "Iznos poreza",
  "邮箱地址": "Email adresa",
  "今天": "Danas",
  "昨天": "Juče",
  "一周": "Jedna nedelja",
  "搜索": "Pretraga",
  "待完成": "Treba završiti",
  "已完成": "Završeno",
  "全部": "Sve",
  "顾客信息": "Informacije o kupcu",
  "用户昵称": "Korisničko ime",
  "手机号": "Broj telefona",
  "收货地址": "Adresa dostave",
  "取单号": "Broj preuzimanja narudžbine",
  "就餐方式": "Način ručka",
  "订单号": "Broj narudžbine",
  "订单金额": "Iznos narudžbine",
  "订单优惠": "Popust na narudžbinu",
  "实付金额": "Iznos plaćen u stvarnosti",
  "支付方式": "Način plaćanja",
  "备注信息": "Napomene",
  "期望配送时间": "Očekivano vreme dostave",
  "取餐时间": "Vreme preuzimanja",
  "配送费": "Troškovi dostave",
  "退款金额": "Iznos vraćanja novca",
  "准备中": "Priprema u toku",
  "出餐中": "Kuvanje u toku",
  "待取餐": "Čeka se preuzimanje",
  "订单信息": "Informacije o narudžbini",
  "税费详情": "Detalji o porezu",
  "取消订单": "Otkaži narudžbinu",
  "打印小票": "Štampaj račun",
  "出餐": "Posluži jelo",
  "确认送达": "Potvrdi dostavu",
  "退款": "Povrat novca",
  "已退款": "Vraćeno",
  "请输入订单号": "Unesite broj narudžbine",
  "至": "Do",
  "开始日期": "Datum početka",
  "结束日期": "Datum završetka",
  "发送账单": "Pošalji račun",
  "请输入邮箱地址": "Unesite svoju email adresu",
  "确定要催菜吗?": "Da li ste sigurni da želite da pohitamo sa narudžbinom?",
  "确定要完成订单吗?": "Da li ste sigurni da želite da završite narudžbinu?",
  "确定要出餐吗?": "Da li ste sigurni da želite poslužiti jela?",
  "确定要发送账单吗?": "Da li ste sigurni da želite poslati račun?",
  "邮箱不能为空": "Email ne može biti prazan",
  "确定要取消订单吗?": "Da li ste sigurni da želite otkazati narudžbinu?",
  "是否确认此操作?": "Da li ste sigurni da želite potvrditi ovu operaciju?",
  "上传文件只能是excel格式!": "Uploadovan fajl mora biti u Excel formatu!",
  "上传文件大小不能超过 10MB!": "Veličina uploadovanog fajla ne sme biti veća od 10MB!",
  "正在处理,请等待": "Obrađuje se, molimo sačekajte",
  "本次处理失败": "Ovog puta je obrađeno neuspešno",
  "总金额": "Ukupan iznos",
  "可退款金额": "Iznos koji se može vratiti",
  "请输入退款金额": "Unesite iznos povratka novca",
  "超出可退款金额": "Premašuje iznos koji se može vratiti",
  "404错误页面": "404 Stranica greške",
  "合计": "Ukupno",
  "份": "Deo",
  "余额支付": "Plaćanje preostalog iznosa",
  "线下支付(现金支付)": "Plaćanje u gotovini",
  "线下支付(自有微信支付)": "Plaćanje preko WeChat-a",
  "线下支付(自有支付宝支付)": "Plaćanje preko Alipay-a",
  "线下支付(POS刷卡支付)": "Plaćanje karticom na POS uređaju",
  "进行中": "U toku",
  "待付款": "Na čekanju za plaćanje",
  "待配送": "Na čekanju za dostavu",
  "配送中": "U dostavi",
  "待接单": "Na čekanju za prihvatanje",
  "待取货": "Čeka se preuzimanje",
  "已配送": "Dostavljeno",
  "已收货": "Primljeno",
  "待收货": "Na čekanju za prijem",
  "待取消": "Na čekanju za otkazivanje",
  "会员": "Član",
  "商家": "Prodavac",
  "供应商": "Dobavljač",
  "分销": "Distribucija",
  "通知": "Obaveštenje",
  "已付款": "Plaćeno",
  "用户下单": "Korisnik je naručio",
  "收银台下单": "Narudžbina na kasu",
  "扫码下单": "Narudžbina skeniranjem",
  "团购下单": "Narudžbina grupne kupovine",
  "商城订单": "Narudžbina iz prodavnice",
  "积分商城订单": "Narudžbina iz poena prodavnice",
  "余额充值订单": "Narudžbina za dopunu preostalog iznosa",
  "购卡订单": "Narudžbina kupovine kartice",
  "券包订单": "Narudžbina kupovine kupona",
  "配送员押金订单": "Narudžbina depozita dostavljača",
  "团购订单": "Narudžbina grupne kupovine",
  "下单减库存": "Smanjiti zalihu prilikom naručivanja",
  "付款减库存": "Smanjiti zalihu prilikom plaćanja",
  "商家配送": "Dostava prodavca",
  "外卖配送": "Dostava hrane",
  "到店自提": "Preuzimanje u radnji",
  "快递配送": "Kurirska dostava",
  "个人中心": "Lični centar",
  ...srLocale
}

export default sr



// WEBPACK FOOTER //
// ./src/i18n/langs/sr.js